import "./Preview.scss";
import { useEffect, useState } from "react";
import {
  Radio,
  Spin
} from "antd";
import { Section } from '../../FormDeclaration/components'
import { FormDeclaration } from '../..'
import { getJsonSectionPromise, getJsonFormPromise } from './promises'

import { useTranslation } from "react-i18next";

const Preview = ({ currentUser, form, section, lang }) => {
  const [ mode, setMode ] = useState("preview")
  const [ json, setJson ] = useState({})
  const [ formPreview, setFormPreview ] = useState(null)
  const [ sectionPreview, setSectionPreview ] = useState(null)
  const [ isLoading, setIsLoading ] = useState(false)

  useEffect(() => {
    if(form?.sections) {
      let f = { ...form, sections: form.sections.filter(s => s.status === 'ACTIVE')}
      setFormPreview(JSON.parse(JSON.stringify(f)))
    } else {
      setFormPreview(null)
    }
    if(section) {
      setSectionPreview(JSON.parse(JSON.stringify(section)))
    } else {
      setSectionPreview(null)
    }
  }, [form, section])

  const handleChangeMode = (value) => {
    setMode(value)
    if(value === 'json') {
      setIsLoading(true)
      if(formPreview) {
        getJsonFormPromise(formPreview).then(response => {
          setJson(response)
          setIsLoading(false)
        })
      }else {
        getJsonSectionPromise(section).then(response => {
          setJson(response)
          setIsLoading(false)
        })
      }
    }
  }

  return (
    <div className={'form-manager-preview-content form-manager-preview-content-'+(form ? 'form' : 'section')}>
        <div className="preview-mode">
            <Radio.Group value={mode} size="small" buttonStyle="solid" onChange={(e) => handleChangeMode(e.target.value)}>
                <Radio.Button value="preview">HTML</Radio.Button>
                <Radio.Button value="pdf">PDF</Radio.Button>
                {/*<Radio.Button value="json">JSON</Radio.Button>*/}
            </Radio.Group>
        </div>
        { mode !== 'json' ?
        <>
            { formPreview && <FormDeclaration client={currentUser?.cliente} form={formPreview} mode={mode} lang={lang} /> }
            { sectionPreview && <Section section={sectionPreview} mode={mode} lang={lang} /> }
        </>
        :
        <pre className="preview-pdf">
          {
          isLoading ? <Spin size="large" />
          :
            <code>
              {JSON.stringify(json, null, 2)}
            </code>
          }
        </pre>
        }
    </div>
  )
}

export default Preview;
